<script setup>
/* Buefy aveva `$buefy.dialog.confirm`, usato per eliminare pin e board.
 * Oruga — il suo successore per Vue 3 — non ha alcun modulo `dialog`: è
 * l'unico vero buco funzionale fra i due. Qui la conferma è una modale come
 * le altre, quindi eredita Esc, focus trap e ripristino del focus. */
import BaseModal from './BaseModal.vue';

defineProps({
  message: { type: String, required: true },
  confirmLabel: { type: String, default: '' },
  destructive: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);
</script>

<template>
  <BaseModal :title="$t('appName')" @close="emit('close', false)">
    <p class="message">{{ message }}</p>
    <template #footer>
      <button class="btn" type="button" @click="emit('close', false)">
        {{ $t('cancelButton') }}
      </button>
      <button
        class="btn"
        :class="destructive ? 'btn--danger' : 'btn--primary'"
        type="button"
        autofocus
        @click="emit('close', true)"
      >
        {{ confirmLabel || $t('deleteButton') }}
      </button>
    </template>
  </BaseModal>
</template>

<style scoped>
.message {
  margin: 0;
  color: var(--ink);
}
</style>
